var web = {
  	init: function(){
  		web.sliderHome();
  		web.menuShi();
  		web.searchExpand();
  	},
  	sliderHome: function(){
  		if($(".slider-home").length){
      		$('.slider-home').slick({
		        arrows: false,
		        dots: true,
		        infinite: true,
		        autoplay: true,
		        autoplaySpeed: 4000,
		        fade: true,
		        cssEase: 'linear'
      		});
    	}
  	},
  	menuShi: function(){
  		if($(".sidenav").length){
  			$(".openNav").click(function(){
  				document.getElementById("shiSidenav").style.width = "380px";
  				$("header").addClass("nav-active");
  			});
  			$(".closeNav").click(function(){
  				document.getElementById("shiSidenav").style.width = "0";
  				$("header").removeClass("nav-active");
  			});
  		}
  	},
  	searchExpand: function(){
	    function buttonUp(){
	      var inputVal = $('.searchbox-input').val();
	      inputVal = $.trim(inputVal).length;
	      if( inputVal !== 0){
	        $('.searchbox-icon').css('display','none');
	      } else {
	        $('.searchbox-input').val('');
	        $('.searchbox-icon').css('display','block');
	      }
	    }
	    var submitIcon = $('.searchbox-icon');
	    var inputBox = $('.searchbox-input');
	    var searchBox = $('.searchbox');
	    var isOpen = false;
	    submitIcon.click(function(){
	      if(isOpen == false){
	        searchBox.addClass('searchbox-open');
	        inputBox.focus();
	        isOpen = true;
	      } else {
	        searchBox.removeClass('searchbox-open');
	        inputBox.focusout();
	        isOpen = false;
	      }
	    });  
	    submitIcon.mouseup(function(){
	      return false;
	    });
	    searchBox.mouseup(function(){
	      return false;
	    });
	    $(document).mouseup(function(){
	      if(isOpen == true){
	        $('.searchbox-icon').css('display','block');
	        submitIcon.click();
	      }
	    });
	}
}
